module.exports = __webpack_public_path__ + "606e271b8f15e65dc928a3250aab3db5.MP3";